<template>
  <div>
    <v-container fluid>

      <div class="backgroundImg">
        <v-row text-xs-center wrap>
          <v-col cols="12">
            <v-img
            :src="require('../assets/logo.svg')"
            class="my-3 "
            contain
            height="200"
            ></v-img>
          </v-col>
        </v-row>
        <v-row class="align-center justify-center">
          <v-col>
            <div class="text-center">
              <v-btn class="text-center" color="primary" dark large to="/register"> Get Started </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>

    <v-row >
      <v-col cols="12">
        <h3 class="shadow text-center display-1 text-capitalize">The best way to create professional options for your customers</h3>
        <h4 class="shadow text-center heading text-capitalize font-weight-bold">So tech's can focus on what matters, The customers and the work..</h4>
      </v-col>
    </v-row>
    <!-- </div> -->
  </v-container>
  <v-container>

    <v-row>
      <v-container grid-list-xl>
        <v-row row wrap align-center>

          <v-col cols="12">
            <v-card flat class="transparent">
              <v-card-text class="text-center">
                <v-icon style="transform: rotate(180deg);" x-large class="blue--text text--lighten-2">wb_incandescent</v-icon>
              </v-card-text>
              <v-card-title primary-title class="layout justify-center">
                <div class="headline shadow">Why Give Options?</div>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <ul >
                      <li>Customers want options and expect more choices and giving options makes customers more satisfied and feel empowered by having choices</li>
                      <li>When your only giving one option they'll want to go somewhere else or get other bids</li>
                      <li>If you give multiple options the customer is now shopping through you, this gives you a chance to always offer the better value products and services</li>
                      <li>If your not offering something, Your not selling it - You miss 100% of the shots you don't take</li>
                      <li>Having choices reduces buyers remorse since they felt in control when they chose the option</li>
                    </ul>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <ul >
                      <li>When you bundle options you build value with the customer and advance your companies growth</li>
                      <li>Itemizing feels like getting pulverized by each blow</li>
                      <li>Seeing the price on paper is more official and trusted than verbal, seeing it in print is even better</li>
                      <li>Presenting options helps digest the information and choices easier than verbal</li>
                      <li>Having options with financing prices makes suggested work more do-able for some</li>
                    </ul>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6">
            <v-card flat class="transparent">
              <v-card-text class="text-center">
                <v-icon x-large class="blue--text text--lighten-2">flash_on</v-icon>
              </v-card-text>
              <v-card-title primary-title class="layout justify-center">
                <div class="headline shadow">Fast development</div>
              </v-card-title>
              <v-card-text>
                <ul>
                  <li>Eliminate the learning curve and hassle of writing options, calculating pricing and financing</li>
                  <li>Create great options fast, usually 1-5 minutes potentially saving 40-60+ minutes a day vs hand writing</li>
                  <li>Pricing is calculated and financing is automatic over 1k, eliminates human errors</li>
                  <li>Options are very professional and legible which eliminates bad handwriting, mispelling and confusion</li>
                  <li>Present, Print or Email</li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6">
            <v-card flat class="transparent">
              <v-card-text class="text-center">
                <v-icon x-large class="blue--text text--lighten-2">build</v-icon>
              </v-card-text>
              <v-card-title primary-title class="layout justify-center">
                <div class="headline text-center shadow">Custom Builds</div>
              </v-card-title>
              <v-card-text>
                <ul>
                  <li>Built for all trades and services using a flexible structure for custom proposals</li>
                  <li>Saves a history of options for when a customer calls back to have the work done</li>
                  <li>Supports custom presets for instant options</li>
                  <li>Allows Customizing a tasks pricing and descriptions on the spot for edge cases without changing the database</li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="6">
            <v-card flat class="transparent">
              <v-card-text class="text-center">
                <v-icon x-large class="blue--text text--lighten-2">monetization_on</v-icon>
              </v-card-text>
              <v-card-title primary-title class="layout justify-center">
                <div class="headline shadow">Benefits</div>
              </v-card-title>
              <v-card-text>
                <ul>
                  <li>Increases technicians efficiency and effectiveness by Saving time and Helping increase the average ticket and closing rate</li>
                  <li>Print is less confusing and more trustworthy than hand writing</li>
                  <li>Provides consistency across the board</li>
                  <li>Techs are more likely to always give options</li>
                  <li>Improves a technicians morality, presenting better options will lead to more success and happiness which may help the retention rate</li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="6">
            <v-card flat class="transparent">
              <v-card-text class="text-center">
                <v-icon x-large class="blue--text text--lighten-2">touch_app</v-icon>
              </v-card-text>
              <v-card-title primary-title class="layout justify-center">
                <div class="headline text-center shadow">User Experience</div>
              </v-card-title>
              <v-card-text>
                <ul>
                  <li>App is very dynamic and fast, navigate around without losing progress</li>
                  <li>Users can manage their own tasks and services in the company pricebook</li>
                  <li>Only Admins can edit or delete any item in the company pricebook</li>
                  <li>Admins can make other users admins</li>
                  <li>Data is Synced instantly for all users without the page needing to refresh!</li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="6" v-if="false">
            <v-card flat class="transparent">
              <v-card-text class="text-center">
                <v-icon x-large class="blue--text text--lighten-2">flare</v-icon>
              </v-card-text>
              <v-card-title primary-title class="layout justify-center">
                <div class="headline shadow">Quotes</div>
              </v-card-title>
              <v-card-text>
                <ul>
                  <li>Revenue is a representation of the value of the amount of trust were able to build</li>
                  <li>A confused mind says no</li>
                  <li>You miss 100% of the shots you don't take</li>
                  <li>If you dont offer it then you won't sell it</li>
                </ul>
              </v-card-text>
            </v-card>
          </v-col>


        </v-row>
      </v-container>
    </v-row>

    <v-row v-if="false">
      <v-col cols="12" sm="6">
        <h2 class="headline font-weight-bold mb-3">Benefits</h2>
        <h3></h3>
        <ul>
          <li>Eliminate the learning curve for writing options and calculating financing</li>
          <li>create great options fast, usually 1-5 minutes</li>
          <li>Looks very professional and legible: eliminates bad handwriting, mispelling and confusion</li>
          <li>Accurate pricing and automatic financing over 1k - eliminates human errors when calculating pricing</li>
          <li>Present, Print or Email</li>

          <li>Increase call backs to have work done</li>
          <li>History allows for quick retrieval of a previously created option when needed</li>
          <li>Presets : create custom presets for instant options</li>
          <li>print is more credible and official than handwriting</li>
          <li>versitile structure allows for custom sales proposals</li>
          <li>and other benefits..</li>
        </ul>
      </v-col>
      <v-col cols="12" sm="6">
        <h2 class="headline font-weight-bold mb-3">Still todo</h2>
        <ul>
          <li>Options alternative good/better/best</li>
          <li>get subscription time from server</li>
          <li>warranty selects for labor/parts</li>
          <li>Add Pictures Next To Option</li>
          <li>finish company settings page with discounts and eventually financing</li>
          <li>finish main landing cta page, this page</li>
          <li>create success page</li>
          <li>create about page with tips</li>
          <li>sign up new user / company choose service after for pricebook to load</li>
          <li>firebase functions</li>
          <li>save to pdf</li>
          <li>security rules</li>
          <li>firestripe</li>
          <li>connect company id to short version for new users </li>
          <li>fix item add form check</li>
          <li>firestore database backups</li>
          <li>signup company needs validations</li>
          <li></li>
        </ul>
      </v-col>
    </v-row>

    <v-row>
     <v-col cols="12" mb-5>
      <h2 class="headline font-weight-bold mb-3 shadow">Demo Examples</h2>
      <template>
        <v-row>
          <v-col cols="12" md="3" sm="4" v-for="(img, ind) in examples" :key="ind" style="cursor: pointer;" class="elevation-2 my-1">
            <v-img @click="overlay = true, carousel = ind" :src="img.src" contain></v-img>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-overlay :value="overlay" opacity=".8">
           <v-btn
           class="mr-12 pr-6"
           icon
           @click="play = !play"
           >{{play == true ? 'Pause' : 'Play'}} 
           <v-icon>{{this.play == true ? 'pause' : 'play_circle_outline'}}</v-icon>
         </v-btn>
         <v-btn
         icon
         @click="overlay = false"
         >Close 
         <v-icon>close</v-icon>
       </v-btn>
       <template>
         <v-carousel
         v-model="carousel"
         :cycle="play"
         style="height: 95vh; width: 95vw;"
         height="95vh"
         >
         <v-carousel-item
          contain
         v-for="(item,i) in examples"
         :key="i"
         :src="item.src"
         reverse-transition="fade-transition"
         transition="fade-transition"
         >
       </v-carousel-item>
     </v-carousel>
   </template>
 </v-overlay>
</div>
</template>
</v-col>
</v-row>

<section>
  <v-container grid-list-xl>
    <v-row row wrap justify-center class="my-12">
      <v-col cols="12" sm4>
        <v-card flat class="transparent">
          <v-card-title primary-title class="layout justify-center">
            <div class="headline shadow">About Me</div>
          </v-card-title>
          <v-card-text>
            I'm a HVAC Technician At Any Hour Services. Yes, This software was built by a tech for techs, companies and customers.
            I believe this is a great assett for any company and will greatly improve communication, customer satisfaction and employee success.
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm4 offset-sm1>
        <v-card flat class="transparent">
          <v-card-title primary-title class="layout justify-center">
            <div class="headline shadow">Contact</div>
          </v-card-title>
          <v-card-text>
            Cras facilisis mi vitae nunc lobortis pharetra. Nulla volutpat tincidunt ornare.
          </v-card-text>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</section>
</v-container>
</div>
</template>

<script>
  export default {
    data() {
      return {
        play: true,
        overlay: false,
        carousel: 0,
        examples: [
        {
          src: require(`../assets/1a.png`),
        },
        {
          src: require(`../assets/2a.png`),
        },
        {
          src: require(`../assets/5.png`),
        },
        {
          src: require(`../assets/6.png`),
        },
        {
          src: require(`../assets/3.png`),
        },
        {
          src: require(`../assets/4.png`),
        }
        
        ],
      }
    },
    computed: {

    },
    methods: {

    }

  }
</script>

<style>
  ul {
    list-style-type: circle;

  }
  ul li::before {
    /*margin-left: -25px;*/
    /*content: " O ";*/
  }
  ul li {
    font-size: 15px;
  }
  .backgroundImg {
    background-image: url('../assets/background.jpg');
    background-position: center;
    background-size: cover;
  }
  .black {
    background: black;
  }
  .btnFloat {
    position: sticky;
    top: 50px;
  }
  .shadow {
    text-shadow: 2px 2px 2px skyblue;
  }


</style>
